import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import Icon from "../Icon";
import useDarkMode from "use-dark-mode";

const Breadcrumb = ({ className = '' }) => {
  const location = useLocation();
  const darkMode = useDarkMode(false);
  const params = useParams();

  const formatSegment = (segment) => {
    if (/^[A-Z0-9_]+$/.test(segment)) {
      return segment;
    }
    return segment
      .replace(/&/g, ' & ') 
      .split(/(?=[A-Z])|[-_]/g)
      .map(word => word.trim())
      .filter(word => word.length > 0)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
    
    const isRolesUpdatePath = 
      pathSegments.length >= 4 && 
      pathSegments[0] === 'settingsDashboard' &&
      pathSegments[1] === 'accessControl' &&
      pathSegments[2] === 'roles' &&
      pathSegments[3] === 'update';
    const processedSegments = isRolesUpdatePath
      ? pathSegments.filter(segment => segment !== 'update')
      : pathSegments;

    return processedSegments.map((segment, index) => {
      const path = isRolesUpdatePath
        ? `/${pathSegments.slice(0, index + (index >= 3 ? 2 : 1)).join('/')}`
        : `/${pathSegments.slice(0, index + 1).join('/')}`;
        
      return {
        text: formatSegment(segment),
        path,
        isLast: index === processedSegments.length - 1
      };
    });
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs.length === 0) return null;

  return (
    <nav style={{padding:"20px"}} className={`flex items-center space-x-2 ${className}`}>
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={crumb.path}>
          {index > 0 && <Icon name="arrow" size="24" fill="#6F767E" />}
          {crumb.isLast ? (
            <span className={darkMode.value ? "text-white" : "text-gray-900"} style={{fontSize:"17px", fontWeight:"bold"}}>
              {crumb.text}
            </span>
          ) : (
            <Link to={crumb.path} className="text-gray-500 hover:text-gray-700 transition-colors" style={{fontSize:"17px"}}>
              {crumb.text}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;